import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getDepartmentDetail, getDepartmentUsers } from 'services/api/department/department';

export const departments = createQueryKeys('departments', {
  detail: (id: number) => ({
    queryKey: [id],
    queryFn: ({ signal }) => getDepartmentDetail(id, signal),
  }),
  users: (departmentIds?: string[]) => ({
    queryKey: [departmentIds],
    queryFn: ({ signal }) => getDepartmentUsers(departmentIds, signal),
  }),
});
